"use client";
import GradientButtonIcon from "@/components/ui/custom/gradient-button-icon";
import { ArrowUpRight } from "lucide-react";

function ButtonWeDevlop() {
  return (
    <GradientButtonIcon href="/contact-us" icon={<ArrowUpRight className="size-5" />}>
      Schedule a Consultation Call
    </GradientButtonIcon>
  );
}

export default ButtonWeDevlop;
